<template>
    <div @click="open" :class="$attrs.inputClass">
        <slot name="cell" :value="modelValue" :methods="{open}">{{ displayValue }}
        </slot>
    </div>
    <teleport to="#selectModal">
        <Modal ref="modal" tabindex=-1 v-model:visible="visible" :backdrop="true">
            <template #header>
                <div class="flex justify-between pb-5">
                    <h4 class="font-bold">{{ $attrs.titolo }}</h4>
                </div>

            </template>
            <template #main>
                <slot name="main" :setInternalValue="setInternalValue">
                    <VueMultiselect
                        :options="$attrs.autocomplete.options"
                        v-model="$attrs.autocomplete.selection"
                        :loading="$attrs.autocomplete.isLoading"
                        @update:modelValue="internalModelValue = $event"
                        @search-change="$attrs.autocomplete.search"
                        class="mb-3"
                        :close-on-select="true" :clear-on-select="false"
                        deselectLabel="Deseleziona"
                        selectedLabel="Selezionato"
                        selectLabel="Seleziona"
                        v-bind="$attrs"
                    >
                    </VueMultiselect>
                </slot>
                <div class="flex justify-end">
                    <NextButton @click="visible=false" variant="outline-secondary" class="w-44 py-1 px-2 mr-2">Chiudi
                    </NextButton>
                    <NextButton @click="visible=false; $emit('confirm', internalModelValue)" variant="outline-primary"
                                class="w-44 py-1 px-2">Salva
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ModalInput',
    components: {
        NextButton,
        Modal,
    },
    props: {
        modelValue: {
            type: [Array, Object, Number, String]
        },
        options: [Array],
        multiple: {
            type: Boolean,
            default: false
        }
    }
})
export default class ModalInput extends Vue {
    visible = false
    modelValue !: any
    multiple !: boolean
    internalValue = null

    updated() {
        this.internalValue = this.modelValue
    }

    get internalModelValue() {
        return this.internalValue
    }

    set internalModelValue(value: any) {
        this.internalValue = value
    }
    setInternalValue(value:any){
        this.internalModelValue = value
    }

    open() {
        this.visible = true
        this.$nextTick(() => {
            //@ts-ignore
            this.$refs['modal'].$el.focus()
        })
        this.search()
        this.retrieve()
    }

    retrieve(){
        // potrebbe no esistere in caso di sovrascrittura
        if(this.$attrs.autocomplete && this.modelValue){
            //@ts-ignore
            this.$attrs.autocomplete.retrieve(this.modelValue[this.$attrs['track-by']])
        }
    }

    search(){
        if(this.$attrs.autocomplete){
            //@ts-ignore
            this.$attrs.autocomplete.search('')
        }
    }


    get displayValue() {
        try {
            if (this.multiple) {
                return this.modelValue.map((el: any) => {
                    //@ts-ignore
                    return el[this.$attrs.label]
                })
            }
            //@ts-ignore
            return this.modelValue[this.$attrs.label]
        } catch (e) {
            return ''
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
